import { useState, useEffect } from 'react';

const links = [
  { href: '#pan', label: '分类盘点' },
  { href: '#moments', label: '高能瞬间' },
  { href: '#hot', label: '热瓜榜' },
  { href: '#talk', label: '吃瓜FAQ' },
  { href: '#about', label: '关于我们' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const bar = scrolled
    ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/80'
    : 'bg-transparent border-b border-transparent';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${bar}`}
    >
      <div className="mx-auto flex h-[76px] max-w-[1240px] items-center justify-between px-4 md:px-6">
        {/* 品牌 Logo */}
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-10 w-10 items-center justify-center rounded-lg font-display text-xl font-black transition-colors ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            瓜
          </span>
          <span className="flex flex-col justify-center leading-none">
            <span
              className={`font-display text-xl font-black tracking-tight transition-colors ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              八卦吃瓜
            </span>
            <span
              className={`mt-1 text-[9px] font-medium tracking-[0.34em] transition-colors ${
                scrolled ? 'text-secondary-600' : 'text-accent-300'
              }`}
            >
              GOSSIP DAILY
            </span>
          </span>
        </a>

        {/* 桌面端导航 */}
        <nav
          aria-label="站点导航"
          className="hidden items-center gap-7 md:flex"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-background-100/90 hover:text-accent-300'
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* 右侧动作 */}
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            className={`hidden whitespace-nowrap items-center gap-1.5 rounded-md px-4 py-2 text-sm font-semibold transition-colors sm:inline-flex ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-primary-700 hover:bg-background-100'
            }`}
          >
            找小编
            <i className="ri-chat-3-line text-base"></i>
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors md:hidden ${
              scrolled
                ? 'border-background-200 text-foreground-800'
                : 'border-background-50/40 text-background-50'
            }`}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-5 pb-6 pt-3 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
            >
              找小编
              <i className="ri-chat-3-line ml-1 text-base"></i>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}